import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { of, retry, delay } from 'rxjs';

export const retryInterceptor: HttpInterceptorFn = (req, next) => {
  const maxRetries = 3;
  const delayTime = 1500;
  return next(req).pipe(
    retry({
      count: maxRetries,
      delay: (error) => {
        if (error instanceof HttpErrorResponse && (error.status === 0 || error.status >= 500)) {
          return of(error).pipe(delay(delayTime));
        }
        throw error;
      },
    }),
  );
};
